import * as Actions from '../actions';

const initialState = {
    authNotifications: [],
    isNotificationLoaded: false,
    currentNotification: {
        notification_id: 0,
        NotificationHeader: '',
        NotificationContent: '',
        NotificationReference: '',
        NotificationReferenceID: 0,
        NotificationType: '',
        ReferenceDisplay: '',
        instructor_id: 0,
        AuthList: []
    }
}

const notification = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_NOTIFICATION_LOADED):
            {
                return {
                    ...state,
                    isNotificationLoaded: action.payload
                }
            }
        case (Actions.GET_NOTIFICATION):
            {
                return {
                    ...state,
                    currentNotification: { ...state.currentNotification, ...action.payload }
                }
            }
        case (Actions.UPDATE_NOTIFICATION_FORM):
            {
                return {
                    ...state,
                    currentNotification: { ...state.currentNotification, ...action.payload }
                }
            }
        case (Actions.GET_NOTIFICATIONS):
            {
                return {
                    ...state,
                    authNotifications: action.payload
                }
            }
        case (Actions.SET_NOTIFICATION_REFERENCE):
            {
                return {
                    ...state,
                    currentNotification: { ...state.currentNotification, ...action.payload }
                }
            }
        case (Actions.AUTH_VIEW_NOTIFICATION):
            {
                return {
                    ...state,
                    authNotifications: state.authNotifications.map(n => {
                        if (parseInt(n.notification_id) === parseInt(action.payload)) {
                            return {
                                ...n, Viewed: 1
                            }
                        }
                        return { ...n }
                    })
                }
            }
        case (Actions.GENERATE_NOTIFICATIONS):
            {
                return {
                    ...state,
                    authNotifications: action.payload
                }
            }
        case  (Actions.RESOLVE_NOTIFICATION):
            {
                return {
                    ...state,
                    authNotifications: state.authNotifications.filter(n => n.notification_relation_id != action.payload)
                }
            }
        default:
            {
                return state
            }
    }
}

export default notification;


// WEBPACK FOOTER //
// src/main/content/notification/store/reducers/notification.reducer.js